export default __webpack_public_path__ + "static/media/glyphs-no-3.7aea6911.ogg";